import {useQuery, useQueryClient} from "@tanstack/react-query";

import {eatClubClient} from "@globals/config/apiClient";
import {UpcomingFavoriteItem} from "@globals/types/UpcomingFavorites";

export const FAVORITES_QUERY = "FAVORITES_QUERY";

export function getUpcomingFavoriteItems(): Promise<UpcomingFavoriteItem[]> {
  return eatClubClient
    .get("/member/api/accounts/upcoming-favorites/")
    .then((response) => response.data);
}

type UseUpcomingFavoritesReturnData = {
  favorites: UpcomingFavoriteItem[];
  reset: () => void;
  isLoading: boolean;
};

export default function useUpcomingFavorites(): UseUpcomingFavoritesReturnData {
  const queryClient = useQueryClient();

  const {data, isPending} = useQuery({
    queryKey: [FAVORITES_QUERY],
    queryFn: getUpcomingFavoriteItems,
  });

  const resetFavorites = () =>
    queryClient.invalidateQueries({queryKey: [FAVORITES_QUERY]});

  return {
    favorites: data || [],
    reset: resetFavorites,
    isLoading: isPending,
  };
}
